const signelaval5Base = {
  body_background_color: '#454897',
  title_font: 'HeadingPro',
  text_font: 'TTCommons',
  text_size: 18,
  title_size: 42,
  title_lineheight: 40,
  subtitleH3_font_weight: '600',
  logo_image_url: 'signelaval5.png',
  text_color: '#454897',
  number_hidden: true,
  token_margin_right: 10,
  header_full_height: true,
  header_no_margin: true,
  header_no_border: true,
  logo_full_width: true,
  button_border_width: 1,
  button_color: '#ee6251',
  button_hover_text_color: '#ee6251',
  button_radius: 50,
  button_outlined_border_color: '#ee6251',
  button_outlined_hover_border_color: '#ee6251',
  button_half_text_color: '#ee6251',
  button_half_border_color: '#ee6251'
}

export const signelaval5L = {
  ...signelaval5Base,
  token_url: 'signelaval5/signelaval5-2.png'
}

export const signelaval5V = {
  ...signelaval5Base,
  token_url: 'signelaval5/signelaval5-3.png'
}
